import type { ReactElement } from 'react';
import styles from './PackageDetailsServiceList.module.scss';
import FontAwesomeIcon, {
  regularCheck
} from 'common/components/FontAwesomeIcon';
import { sortServices } from 'packages/common/sorters/sortServices';
import type { MeetingPackage, VenuePackage, Service } from 'packages/types';

type PackageWithServices = MeetingPackage | VenuePackage;

type Props = {
  allServices: Service[];
  includedServiceIds: PackageWithServices['serviceIds'];
};

export function PackageDetailsServiceList({
  allServices,
  includedServiceIds
}: Props): ReactElement {
  const sortedAvailableServices = sortServices(
    allServices.filter(service => includedServiceIds.includes(service.id))
  );
  return (
    <div className={styles.serviceList}>
      <div className={styles.serviceListHeading}>
        {__('packages.details.services')}:
      </div>
      <ul className="fa-ul">
        {sortedAvailableServices.map(service => (
          <li className={styles.service} key={service.id}>
            <span className="fa-li">
              <FontAwesomeIcon icon={regularCheck} />
            </span>
            {service.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
